import { MessageNotificationProps } from 'stream-chat-react';
import { makeStyles } from '@material-ui/styles';
import ArrowFix from '../../icons/ArrowFix';
import { Text, MainButton } from '@bizzabo/design-system';

type MessageNotificationWithCloseProps = MessageNotificationProps & { onClosePinView: () => void };

const MessageNotification: React.FC<MessageNotificationWithCloseProps> = props => {
    const classes = useStyles();

    const { onClick, showNotification, onClosePinView } = props;

    if (!showNotification) {
        return null;
    }

    const onClickOnMessage = e => {
        onClosePinView();

        // TODO: in order not to use setTimeout => we need to refactor pin messages view
        // that not know to close himself from outside (like dialog do)
        // this refactor can take a day or 2 => and we want this for GA2
        // we decide to do this quick win

        // LOGIC - This timeout added => because when we have pin view and we need to close it
        // we must wait for a little to close the pin view and then we can scroll to down
        setTimeout(() => {
            onClick(e);
        }, 10);
    };

    return (
        <div className={classes.container}>
            <MainButton
                variant="fill"
                className={classes.button}
                before={<ArrowFix rotate={90} fill={'#fff'} />}
                onClick={onClickOnMessage}
            >
                <Text variant="t80" className={classes.text}>
                    New messages
                </Text>
            </MainButton>
        </div>
    );
};

const useStyles = makeStyles(
    () => ({
        container: {
            position: 'absolute',
            bottom: 12,
            left: '50%',
            transform: 'translateX(-50%)',
        },
        button: {
            height: 24,
        },
        text: {
            verticalAlign: 'sub',
        },
    }),
    {
        classNamePrefix: MessageNotification.name,
    }
);

export default MessageNotification;
